// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var MenuV5 = require("../../common/Components/menu/MenuV5.bs.js");
var ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var Icon__Jsx3 = require("../../../uikit/reason/atoms/Icon/Icon__Jsx3.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Array = require("@rescript/core/src/Core__Array.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var Theme__Color = require("../../../reason/common/Theme/Theme__Color.bs.js");
var SystemMessages = require("../../../reason/systemMessages/SystemMessages.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var FragmentErrorBoundary = require("../../common/ErrorHandling/FragmentErrorBoundary.bs.js");
var RenewBuyerNeedMutation = require("../ClientPage/RenewBuyerNeedMutation.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var OwnBuyerNeedStatusLabel = require("../OwnBuyerNeedStatusLabel.bs.js");
var WithdrawBuyerNeedDialog = require("../ClientPage/WithdrawBuyerNeedDialog.bs.js");
var MarkBuyerNeedAsPurchased = require("../ClientPage/MarkBuyerNeedAsPurchased.bs.js");
var MyClientsWidgetRowLayout = require("./MyClientsWidgetRowLayout.bs.js");
var MyClientsWidgetComponents = require("./MyClientsWidgetComponents.bs.js");
var MyClientsWidgetDeleteDialog = require("./MyClientsWidgetDeleteDialog.bs.js");
var MarkBuyerNeedAsInContractDialog = require("../ClientPage/MarkBuyerNeedAsInContractDialog.bs.js");
var MyClientsWidgetBuyer_buyer_graphql = require("../../../__generated__/MyClientsWidgetBuyer_buyer_graphql.bs.js");
var MyClientsWidgetBuyer_Menu_buyer_graphql = require("../../../__generated__/MyClientsWidgetBuyer_Menu_buyer_graphql.bs.js");
var MyClientsWidgetBuyer_name_buyer_graphql = require("../../../__generated__/MyClientsWidgetBuyer_name_buyer_graphql.bs.js");
var MyClientsWidgetBuyer_status_buyer_graphql = require("../../../__generated__/MyClientsWidgetBuyer_status_buyer_graphql.bs.js");

var convertFragment = MyClientsWidgetBuyer_Menu_buyer_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MyClientsWidgetBuyer_Menu_buyer_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(MyClientsWidgetBuyer_Menu_buyer_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, MyClientsWidgetBuyer_Menu_buyer_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(MyClientsWidgetBuyer_Menu_buyer_graphql.node, convertFragment, fRef);
}

var BuyerFragment_buyerNeedMatchingType_decode = MyClientsWidgetBuyer_Menu_buyer_graphql.Utils.buyerNeedMatchingType_decode;

var BuyerFragment_buyerNeedMatchingType_fromString = MyClientsWidgetBuyer_Menu_buyer_graphql.Utils.buyerNeedMatchingType_fromString;

var BuyerFragment = {
  buyerNeedMatchingType_decode: BuyerFragment_buyerNeedMatchingType_decode,
  buyerNeedMatchingType_fromString: BuyerFragment_buyerNeedMatchingType_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function MyClientsWidgetBuyer$Menu(props) {
  var buyer = use(props.buyer);
  var hasActivityReport = Core__Array.keepSome(Core__Option.getOr(Core__Option.map(buyer.buyerNeed.broadcasts, (function (connection) {
                    return connection.edges;
                  })), [])).some(function (edge) {
        var match = edge.node.activityReport;
        if (match.__typename === "ActivityReportV5") {
          return true;
        } else {
          return false;
        }
      });
  var matchesCount = Core__Option.getOr(Core__Option.map(buyer.buyerNeed.matches, (function (m) {
              return m.totalCount;
            })), 0);
  var match = React.useState(function () {
        return false;
      });
  var setDeleteDialogOpen = match[1];
  var match$1 = SystemMessages.useSystemMessages();
  var addMessage = match$1.addMessage;
  var handleRenewingError = function () {
    addMessage(SystemMessages.Message.make(undefined, "error", "There was an error making the buyer need active. Please try again...", 5000, undefined, undefined));
  };
  var match$2 = RenewBuyerNeedMutation.use(buyer.buyerNeed.nodeId, handleRenewingError, false);
  var makeBuyerNeedActiveIsLoading = match$2[1];
  var makeBuyerNeedActive = match$2[0];
  var match$3 = React.useState(function () {
        return false;
      });
  var setWithdrawDialogOpen = match$3[1];
  var match$4 = React.useState(function () {
        return false;
      });
  var setMarkAsPurchasedDialogOpen = match$4[1];
  var match$5 = React.useState(function () {
        return false;
      });
  var setMarkAsInContractDialogOpen = match$5[1];
  var match$6 = buyer.buyerNeed.status;
  var tmp;
  switch (match$6.__typename) {
    case "ActiveBuyerNeed" :
        tmp = match$6.isRenewable ? "Renew or change status" : "Change status";
        break;
    case "ExpiredBuyerNeed" :
        tmp = "Renew or change status";
        break;
    default:
      tmp = "Change status";
  }
  var match$7 = buyer.buyerNeed.status;
  var tmp$1;
  var exit = 0;
  switch (match$7.__typename) {
    case "ActiveBuyerNeed" :
        if (match$7.isRenewable) {
          exit = 1;
        } else {
          tmp$1 = null;
        }
        break;
    case "ExpiredBuyerNeed" :
        exit = 1;
        break;
    default:
      tmp$1 = JsxRuntime.jsx(MenuV5.MenuItem.make, {
            onAction: (function () {
                makeBuyerNeedActive();
              }),
            isDisabled: makeBuyerNeedActiveIsLoading,
            children: "Change to active"
          });
  }
  if (exit === 1) {
    tmp$1 = JsxRuntime.jsx(MenuV5.MenuItem.make, {
          onAction: (function () {
              makeBuyerNeedActive();
            }),
          isDisabled: makeBuyerNeedActiveIsLoading,
          children: "Renew buyer need"
        });
  }
  var match$8 = buyer.buyerNeed.status;
  var tmp$2;
  tmp$2 = match$8.__typename === "PurchasedBuyerNeed" ? null : JsxRuntime.jsx(MenuV5.MenuItem.make, {
          onAction: (function () {
              setMarkAsPurchasedDialogOpen(function (param) {
                    return true;
                  });
            }),
          children: "Mark as purchased"
        });
  var match$9 = buyer.buyerNeed.status;
  var tmp$3;
  tmp$3 = match$9.__typename === "InContractBuyerNeed" ? null : JsxRuntime.jsx(MenuV5.MenuItem.make, {
          onAction: (function () {
              setMarkAsInContractDialogOpen(function (param) {
                    return true;
                  });
            }),
          children: "Mark as in contract"
        });
  var match$10 = buyer.buyerNeed.status;
  var tmp$4;
  tmp$4 = match$10.__typename === "WithdrawnBuyerNeed" ? null : JsxRuntime.jsx(MenuV5.MenuItem.make, {
          onAction: (function () {
              setWithdrawDialogOpen(function (param) {
                    return true;
                  });
            }),
          children: "Withdraw buyer need"
        });
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsx(MyClientsWidgetDeleteDialog.make, {
                      client: buyer.fragmentRefs,
                      isOpen: match[0],
                      onCancel: (function () {
                          setDeleteDialogOpen(function (param) {
                                return false;
                              });
                        }),
                      onSuccess: (function () {
                          setDeleteDialogOpen(function (param) {
                                return false;
                              });
                        }),
                      connectionId: props.connectionId
                    }),
                JsxRuntime.jsx(WithdrawBuyerNeedDialog.make, {
                      nodeId: buyer.buyerNeed.nodeId,
                      isOpen: match$3[0],
                      close: (function () {
                          setWithdrawDialogOpen(function (param) {
                                return false;
                              });
                        })
                    }),
                JsxRuntime.jsx(MarkBuyerNeedAsPurchased.make, {
                      nodeId: buyer.buyerNeed.nodeId,
                      isOpen: match$4[0],
                      close: (function () {
                          setMarkAsPurchasedDialogOpen(function (param) {
                                return false;
                              });
                        })
                    }),
                JsxRuntime.jsx(MarkBuyerNeedAsInContractDialog.make, {
                      nodeId: buyer.buyerNeed.nodeId,
                      isOpen: match$5[0],
                      close: (function () {
                          setMarkAsInContractDialogOpen(function (param) {
                                return false;
                              });
                        })
                    }),
                JsxRuntime.jsxs(MenuV5.Menu.make, {
                      button: JsxRuntime.jsx(ButtonsV5.Button.make, {
                            className: "!border-none",
                            children: Caml_option.some(JsxRuntime.jsx(Icon__Jsx3.make, {
                                      icon: "ThreeDots",
                                      size: 16,
                                      color: Theme__Color.black
                                    }))
                          }),
                      children: [
                        JsxRuntime.jsx(MenuV5.MenuItem.make, {
                              href: "/client_needs/" + buyer.buyerNeed.id + "/edit",
                              children: "Edit buyer need"
                            }),
                        buyer.buyerNeed.buyerNeedMatchingType === "QUIET" ? JsxRuntime.jsx(MenuV5.MenuItem.make, {
                                href: "/client_needs/" + buyer.buyerNeed.id + "/broadcast",
                                children: "Broadcast buyer need"
                              }) : null,
                        JsxRuntime.jsxs(MenuV5.Submenu.make, {
                              name: tmp,
                              children: [
                                tmp$1,
                                tmp$2,
                                tmp$3,
                                tmp$4
                              ]
                            }),
                        matchesCount > 0 ? JsxRuntime.jsx(MenuV5.MenuItem.make, {
                                href: "/my_clients/" + buyer.id + "#matches",
                                children: "View matches (" + matchesCount.toString() + ")"
                              }) : null,
                        hasActivityReport ? JsxRuntime.jsx(MenuV5.MenuItem.make, {
                                href: "/client_needs/" + buyer.buyerNeed.id + "/report",
                                children: "View activity report"
                              }) : null,
                        JsxRuntime.jsx(MenuV5.MenuItem.make, {
                              onAction: (function () {
                                  setDeleteDialogOpen(function (param) {
                                        return true;
                                      });
                                }),
                              children: "Delete buyer"
                            })
                      ]
                    })
              ]
            });
}

var Menu = {
  BuyerFragment: BuyerFragment,
  make: MyClientsWidgetBuyer$Menu
};

var convertFragment$1 = MyClientsWidgetBuyer_name_buyer_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MyClientsWidgetBuyer_name_buyer_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(MyClientsWidgetBuyer_name_buyer_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, MyClientsWidgetBuyer_name_buyer_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(MyClientsWidgetBuyer_name_buyer_graphql.node, convertFragment$1, fRef);
}

var BuyerFragment_buyerNeedMatchingType_decode$1 = MyClientsWidgetBuyer_name_buyer_graphql.Utils.buyerNeedMatchingType_decode;

var BuyerFragment_buyerNeedMatchingType_fromString$1 = MyClientsWidgetBuyer_name_buyer_graphql.Utils.buyerNeedMatchingType_fromString;

var BuyerFragment$1 = {
  buyerNeedMatchingType_decode: BuyerFragment_buyerNeedMatchingType_decode$1,
  buyerNeedMatchingType_fromString: BuyerFragment_buyerNeedMatchingType_fromString$1,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function MyClientsWidgetBuyer$Name(props) {
  var buyer = use$1(props.buyer);
  var registrationState = Core__Array.reduce(Core__Array.keepSome(Core__Option.getOr(Core__Option.map(buyer.contacts, (function (contacts) {
                      return contacts.edges;
                    })), [])), "Uninvited", (function (acc, contact) {
          var match = contact.node.clientAccessStatus;
          switch (acc) {
            case "Uninvited" :
                switch (match.__typename) {
                  case "ClientContactInvited" :
                      return "Invited";
                  case "ClientContactRegistered" :
                  case "__unselected" :
                      break;
                  
                }
                break;
            case "Registered" :
                return acc;
            case "Invited" :
                break;
            
          }
          switch (match.__typename) {
            case "ClientContactRegistered" :
                return "Registered";
            case "ClientContactInvited" :
            case "__unselected" :
                return acc;
            
          }
        }));
  var match = buyer.buyerNeed.matchingType;
  var buyerNeedType = match !== undefined && (match === "BROADCAST" || match === "QUIET") ? (
      match === "BROADCAST" ? "Broadcast buyer need" : "Quiet buyer need"
    ) : "Buyer need";
  var tmp;
  switch (registrationState) {
    case "Uninvited" :
        tmp = "";
        break;
    case "Registered" :
        tmp = " (registered)";
        break;
    case "Invited" :
        tmp = " (invited)";
        break;
    
  }
  var match$1 = buyer.buyerNeed.autoNotify;
  var tmp$1;
  if (match$1 !== undefined && match$1) {
    switch (registrationState) {
      case "Uninvited" :
          tmp$1 = null;
          break;
      case "Registered" :
      case "Invited" :
          tmp$1 = JsxRuntime.jsx(MyClientsWidgetComponents.AutoNotifyIcon.make, {});
          break;
      
    }
  } else {
    tmp$1 = null;
  }
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: buyerNeedType + tmp,
                              className: "text-gray-500 uppercase font-light"
                            }),
                        tmp$1
                      ],
                      className: "flex gap-2 items-center"
                    }),
                JsxRuntime.jsx(ButtonsV5.Link.make, {
                      href: "my_clients/" + buyer.id,
                      children: Caml_option.some(JsxRuntime.jsx("div", {
                                children: buyer.displayName,
                                className: "text-lg"
                              }))
                    })
              ],
              className: "flex flex-col gap-1"
            });
}

var Name = {
  BuyerFragment: BuyerFragment$1,
  make: MyClientsWidgetBuyer$Name
};

var convertFragment$2 = MyClientsWidgetBuyer_status_buyer_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MyClientsWidgetBuyer_status_buyer_graphql.node, convertFragment$2, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(MyClientsWidgetBuyer_status_buyer_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, MyClientsWidgetBuyer_status_buyer_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(MyClientsWidgetBuyer_status_buyer_graphql.node, convertFragment$2, fRef);
}

var BuyerFragment$2 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$2,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

function MyClientsWidgetBuyer$Status$WithoutErrorBoundary(props) {
  var buyer = use$2(props.buyer);
  return JsxRuntime.jsx(OwnBuyerNeedStatusLabel.make, {
              buyerNeed: buyer.buyerNeed.fragmentRefs
            });
}

var WithoutErrorBoundary = {
  BuyerNeedStatusLabel: undefined,
  BuyerFragment: BuyerFragment$2,
  make: MyClientsWidgetBuyer$Status$WithoutErrorBoundary
};

function MyClientsWidgetBuyer$Status(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
              fragmentDisplayName: "buyer status",
              children: JsxRuntime.jsx(MyClientsWidgetBuyer$Status$WithoutErrorBoundary, {
                    buyer: props.buyer
                  })
            });
}

var Status = {
  WithoutErrorBoundary: WithoutErrorBoundary,
  make: MyClientsWidgetBuyer$Status
};

var convertFragment$3 = MyClientsWidgetBuyer_buyer_graphql.Internal.convertFragment;

function waitForFragmentData$3(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MyClientsWidgetBuyer_buyer_graphql.node, convertFragment$3, fRef);
}

function use$3(fRef) {
  return RescriptRelay_Fragment.useFragment(MyClientsWidgetBuyer_buyer_graphql.node, convertFragment$3, fRef);
}

function useOpt$3(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, MyClientsWidgetBuyer_buyer_graphql.node, convertFragment$3);
}

function readResolverFragment$3(fRef) {
  return RescriptRelay_Fragment.read(MyClientsWidgetBuyer_buyer_graphql.node, convertFragment$3, fRef);
}

var BuyerFragment$3 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$3,
  waitForFragmentData: waitForFragmentData$3,
  use: use$3,
  useOpt: useOpt$3,
  readResolverFragment: readResolverFragment$3
};

function MyClientsWidgetBuyer(props) {
  var buyer = use$3(props.buyer);
  return JsxRuntime.jsx(MyClientsWidgetRowLayout.make, {
              name: JsxRuntime.jsx(MyClientsWidgetBuyer$Name, {
                    buyer: buyer.fragmentRefs
                  }),
              status: JsxRuntime.jsx(MyClientsWidgetBuyer$Status, {
                    buyer: buyer.fragmentRefs
                  }),
              menu: JsxRuntime.jsx(MyClientsWidgetBuyer$Menu, {
                    buyer: buyer.fragmentRefs,
                    connectionId: props.connectionId
                  })
            });
}

var Layout;

var Components;

var Link;

var DeleteDialog;

var make = MyClientsWidgetBuyer;

exports.Layout = Layout;
exports.Components = Components;
exports.Link = Link;
exports.DeleteDialog = DeleteDialog;
exports.Menu = Menu;
exports.Name = Name;
exports.Status = Status;
exports.BuyerFragment = BuyerFragment$3;
exports.make = make;
/* react Not a pure module */
